export default class Answer{
    answer;
    correct;
    constructor(answer,correct) {
        this.answer = answer;
        this.correct = correct;

    }
}